var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ParentBar'),_c('PermissionValidation',{attrs:{"marketId":_vm.marketId,"rule":"enableViewReports"}},[_c('layout',{attrs:{"isSuccess":true},scopedSlots:_vm._u([{key:"containerZone",fn:function(){return [_c('report-layout',[_c('router-view')],1)]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }